// Angular
import { Component, EventEmitter, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// External
import { ApiService } from "./../../services/api";
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import * as moment from "moment";
import { FacilityTypes } from "./../../models/facitlity-types";
import { ElementRef, NgZone, ViewChild } from "@angular/core";
// import { } from "googlemaps";
import { MapsAPILoader } from "@agm/core";
import { MatSnackBar } from "@angular/material";

@Component({
  templateUrl: "./profile.component.html",
})
export class CompanyProfileComponent implements OnInit {
  public club: any;
  public form: FormGroup;
  public list: Array<any>;
  public offerList: Array<any>;
  public courses: Array<any>;
  public imageLoader = true;
  public disabled: boolean;
  public avatarLoading: boolean;
  public coverLoading: boolean;
  public isBgUpload = false;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public isAvatarModal = false;
  public isBgModal = false;

  public attachment: any;
  public attachmentExt: string;
  public zoom: number;
  public address: string;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  constructor(
    private route: ActivatedRoute,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private apiService: ApiService,
    private mapsAPILoader: MapsAPILoader,
    public snackBar: MatSnackBar,
    private ngZone: NgZone
  ) {
    this.offerList = [];

    this.club = this.oAuthService.getClub();
  }

  ngOnInit() {
    this.initData();
    this.zoom = 4;
    this.latitude = 39.8282;
    this.longitude = -98.5795;

    this.setCurrentPosition();
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"],
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // console.log(place)
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.club.address = place.formatted_address;
          const results = place.address_components;
          this.form.patchValue({ address: this.club.address });

          this.form.patchValue({
            city: this.findResult(results, "administrative_area_level_2"),
          });
          this.club.state = this.findResult(
            results,
            "administrative_area_level_1"
          );
          this.club.country = this.findResult(results, "country");
          this.form.patchValue({
            postCode: this.findResult(results, "postal_code"),
          });
          if (!this.club.location) this.club.location = { lat: 0, lon: 0 };
          this.club.location.lat = place.geometry.location.lat();
          this.club.location.lon = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }

  public onAddressChange(val) {
    console.log(val);
  }
  public findResult = function (results, name) {
    const result = lodash.find(results, function (obj) {
      return obj.types[0] === name;
    });
    return result ? result.long_name : null;
  };

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  public initData() {
    this.club = this.oAuthService.getClub();
    if (this.club.address) {
      this.address = this.club.address;
    }
    this.form = new FormGroup({
      name: new FormControl(this.club.name, Validators.required),
      phone: new FormControl(this.club.phone, Validators.pattern("[0-9 ]+")),
      info: new FormControl(this.club.info, Validators.required),
      address: new FormControl(this.club.address, Validators.required),
      websiteLink: new FormControl(this.club.websiteLink, Validators.required),

      city: new FormControl(this.club.city, Validators.required),
      postCode: new FormControl(this.club.postCode, Validators.required),
      contactPersonName: new FormControl(
        this.club.contactPersonName,
        Validators.required
      ),
      contactPersonEmailId: new FormControl(
        this.club.contactPersonEmailId,
        Validators.required
      ),
    });
    this.disabled = false;
    this.avatarLoading = false;
    this.coverLoading = false;

    this.fireDatabase.object(`/users/${this.club.cid}`).subscribe((club) => {
      this.club = club;
      this.club.cid = club.$key;
      if (!this.club.commission) {
        this.club.commission = 10;
      }
      if (this.club.isPrivate == 1) {
        this.club.privateAccount = true;
      }
      if (this.club.isPrivate == 2) {
        this.club.privateAccount = false;
      }
      console.log(this.club);
      this.form = new FormGroup({
        name: new FormControl(this.club.name, Validators.required),
        phone: new FormControl(this.club.phone, Validators.pattern("[0-9 ]+")),
        websiteLink: new FormControl(
          this.club.websiteLink,
          Validators.required
        ),

        info: new FormControl(this.club.info, Validators.required),
        address: new FormControl(this.club.address),
        city: new FormControl(this.club.city, Validators.required),
        postCode: new FormControl(this.club.postCode, Validators.required),
        contactPersonName: new FormControl(
          this.club.contactPersonName,
          Validators.required
        ),
        contactPersonEmailId: new FormControl(
          this.club.contactPersonEmailId,
          Validators.required
        ),
      });
      // this.oAuthService.setClub(this.club);

      this.imageLoader = false;
    });
  }
  PreviewBackGroundImage = false;
  onPreviewBackGroundImage(event)
  {
    this.PreviewBackGroundImage = true;
    $("#backGroundImageModal").modal('show');
  }
  
  public changeAvatar(): void {
    if (!this.attachment) {
      return;
    }

    const fileName = `${this.club.cid}_${moment().unix()}`;
    console.log(this.attachment);

    this.isBgUpload = true;
    this.apiService
      .upload("/users/avatars", fileName, this.attachment.file, {
        customMetadata: { uid: this.club.cid },
      })
      .then((result) => {
        console.log(result);

        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.isBgUpload = false;
            this.club.avatar = result.downloadURL;
            this.club.avatar_thumb = result.downloadURL;
            let ob = {
              avatar: this.club.avatar,
              avatar_thumb: this.club.avatar_thumb 
            }
             this.apiService
            .update(`/users/${this.club.cid}`, ob)
            .then(() => {
              this.initData();
              this.disabled = false;
              $("#myModal").modal("hide");
              $(".modal-backdrop").hide();
              this.snackBar.open("Avatar updated successfully!!", "OK!", {
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);

              this.disabled = false;
            });
          };
          image.onerror = () => {
            this.isBgUpload = false;
          };
        } else {
          this.isBgUpload = false;
        }
        this.toggleAvater();
        this.attachment = null;
        // window.location.reload()
      })
      .catch((error) => {
        console.error(error);

        this.avatarLoading = false;
      });
  }

  public changeBackground(): void {
    if (!this.attachment) {
      return;
    }

    const fileName = `${this.club.cid}_${moment().unix()}`;

    this.isBgUpload = true;
    this.apiService
      .upload("/users/background", fileName, this.attachment.file, {
        customMetadata: { uid: this.club.cid },
      })
      .then((result) => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.isBgUpload = false;
            this.club.background = result.downloadURL;
            this.club.background_thumb = result.downloadURL;
            this.isBgUpload = false;
             let ob = {
              background: this.club.background,
              background_thumb: this.club.background_thumb 
            }
             this.apiService
            .update(`/users/${this.club.cid}`, ob)
            .then(() => {
              this.initData();
              this.disabled = false;
              $("#myModal").modal("hide");
              $(".modal-backdrop").hide();
              this.snackBar.open("Background updated successfully!!", "OK!", {
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);

              this.disabled = false;
            });

            this.toggleBg();
            this.attachment = null;
          };
          image.onerror = () => {
            this.isBgUpload = false;
          };
        } else {
          this.isBgUpload = false;
        }
      })
      .catch((error) => {
        console.error(error);

        this.coverLoading = false;
      });
  }

  submit() {
    const ob = {
      info: this.form.controls["info"].value,
      phone: this.form.controls["phone"].value + "",
      address: this.form.controls["address"].value
        ? this.form.controls["address"].value
        : null,
      name: this.form.controls["name"].value,
      contactPersonName: this.form.controls["contactPersonName"].value,
      updatedAt: new Date().getTime() / 1000,
      websiteLink: this.form.controls["websiteLink"].value,
      state: this.club.state ? this.club.state : null,
      city: this.form.controls["city"].value,
      country: this.club.country ? this.club.country : null,
      postCode: this.form.controls["postCode"].value,
      location: this.club.location ? this.club.location : null,
      contactPersonEmailId: this.form.controls["contactPersonEmailId"].value,
    };
    console.log(ob);
    this.disabled = true;
    this.apiService
      .update(`/users/${this.club.cid}`, ob)
      .then(() => {
        this.initData();
        this.disabled = false;
        $("#myModal").modal("hide");
        $(".modal-backdrop").hide();
        this.snackBar.open("Profile updated successfully!!", "OK!", {
          duration: 3000,
        });
      })
      .catch((error) => {
        console.error(error);

        this.disabled = false;
      });
  }
  checkFormValid()
  {
    if(this.form.controls["name"].value && this.form.controls["contactPersonName"].value && this.form.controls["contactPersonEmailId"].value)
      return false
    else return true
  }
  changeTextToSmallLetters()
  {
    let text = String(this.form.controls["contactPersonEmailId"].value).toLowerCase()
    this.form.patchValue({ contactPersonEmailId: text });
  }
  submit1() {
    const ob = {
      info: this.form.controls["info"].value,
      phone: this.form.controls["phone"].value + "",
      address: this.form.controls["address"].value
        ? this.form.controls["address"].value
        : null,
      name: this.form.controls["name"].value,
      contactPersonName: this.form.controls["contactPersonName"].value,
      updatedAt: new Date().getTime() / 1000,
      websiteLink: this.form.controls["websiteLink"].value,
      state: this.club.state ? this.club.state : null,
      city: this.form.controls["city"].value,
      country: this.club.country ? this.club.country : null,
      postCode: this.form.controls["postCode"].value,
      location: this.club.location ? this.club.location : null,
      contactPersonEmailId: this.form.controls["contactPersonEmailId"].value,
    };
    console.log(ob);
    this.disabled = true;
    this.apiService
      .update(`/users/${this.club.cid}`, ob)
      .then(() => {
        this.initData();
        this.disabled = false;
        $("#myModal").modal("hide");
        $(".modal-backdrop").hide();
        this.snackBar.open("Profile updated successfully!!", "OK!", {
          duration: 3000,
        });
      })
      .catch((error) => {
        console.error(error);

        this.disabled = false;
      });
  }

  public close() {
    this.initData();
  }
  public facilitySelect(event, facility) {
    console.log(event);
    console.log(facility);
    if (event) {
      this.apiService
        .set(`/users/${this.club.cid}/facility/${facility.id}`, facility.name)
        .then(() => {})
        .catch((error) => {
          console.error(error);
        });
    } else {
      this.apiService
        .set(`/users/${this.club.cid}/facility/${facility.id}`, null)
        .then(() => {})
        .catch((error) => {
          console.error(error);
        });
    }
  }

  toggleAvater() {
    this.isAvatarModal = !this.isAvatarModal;
    this.attachment = null;
  }

  toggleBg() {
    this.isBgModal = !this.isBgModal;
    this.attachment = null;
  }

  changeAttachment(attachment: any): void {
    if (attachment) {
      this.attachment = attachment;

      this.attachmentExt = this.attachment.file.name.split(".").pop();
    } else {
      this.attachmentExt = "";
    }
  }
  async changeData() {
    let obj = {
      isShowPhone:
        this.club.isShowPhone == undefined ? false : this.club.isShowPhone,
      isShowEmail:
        this.club.isShowEmail == undefined ? false : this.club.isShowEmail,
      isShowAddress:
        this.club.isShowAddress == undefined ? false : this.club.isShowAddress,
    };

    await this.apiService.update("users/" + this.club.cid, obj);
    this.snackBar.open("Profile updated successfully!!", "OK!", {
      duration: 3000,
    });
  }

  onAccountChange(event) {
    let privates = event ? 1 : 2;

    this.club.isPrivate = privates;
    this.apiService.set("users/" + this.club.cid + "/isPrivate", privates);
    this.snackBar.open(
      "Profile is now " + (event ? "private" : "public"),
      "OK!",
      {
        duration: 3000,
      }
    );
  }
}
